import React, { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Button, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import closeIcon from "../../../common/assets/images/x-close.png";
import debounce from "lodash.debounce";
import {
  updateFilters,
  setProvisionalDrgFilterSearch,
  getEpisodeIdentiferFilterOptions,
  getMRNFilterOptions,
  getSpecialityFilterOptions,
  getQueueFilterOptions,
  getCoderFilterOptions,
  getPriorityFilterOptions,
  getStatusFilterOptions,
  getHealthFundContractFilterOptions,
  getProvisionalDrgFilterOptions,
  setMRNFilterSearch,
  setSpecialityFilterSearch,
  setEpisodeIdentiferFilterSearch,
  resetFilterByKey,
  setQueueFilterSearch,
  setCoderFilterSearch,
  setAuditorFilterSearch,
  setPriorityFilterSearch,
  setHealthFundFilterContractSearch,
  setStatusFilterSearch,
  resetHimFilters,
  getAuditorsFilterOptions,
  getHealthInformationQueueManagerEpisodes,
  getHealthInformationManagerDashboardOptions,
} from "./redux/HealthInformationManagerSlicer";
import "./HimManagerFilter.css";
import MultiSelect from "../../../utils/MultiSelect";
import { resetCoderFilters } from "../CoderView/redux/CoderScreenSlice";

const HimManagerFilter = ({
  show,
  setShowHimFilter,
  onClose,
  setCoderSearchTerm,
  selectedCoderOptions 
}) => {
  const dispatch = useDispatch();
  const storedRole = sessionStorage.getItem("workspaceRole");
  const {
    healthInformationManagerEpisodesPayload: filtersPayload,
    healthInformationManagerEpisodesPayload1: filtersPayload1,
    episodeIdentiferFilterOptions,
    MRNFilterOptions,
    specialityFilterOptions,
    queueFilterOptions,
    coderFilterOptions,
    priorityFilterOptions,
    statusFilterOptions,
    healthFundContractFilterOptions,
    provisionalDrgFilterOptions,
    auditorsFilterOptions,
  } = useSelector((state) => state.healthInsuranceManager);
  const labelCache = useRef({
    speciality: {},
    queue: {},
    coder: {},
    status: {},
  });
  const breadcrumbExcludeKeys = [
    "page_number",
    "page_size",
    "screen_type",
    "is_global_search",
  ];
  useEffect(() => {
    if (show) {
      // dispatch(resetHimFilters());
      // dispatch(resetFilterByKey("queueFilterOptions"));
      dispatch(
        getEpisodeIdentiferFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getMRNFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getSpecialityFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getAuditorsFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getQueueFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
          screen_type: storedRole,
        }),
      );
      dispatch(
        getCoderFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getPriorityFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getStatusFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getHealthFundContractFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
      dispatch(
        getProvisionalDrgFilterOptions({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  }, [show, dispatch]);

  const losOperatorOptions = [
    { label: ">", value: "gt" },
    { label: "<", value: "lt" },
    { label: ">=", value: "gte" },
    { label: "<=", value: "lte" },
    { label: "=", value: "eq" },
    { label: "!=", value: "neq" },
    { label: "Between", value: "gtlt" },
    { label: "Between (Inclusive)", value: "gtelte" },
  ];

  const episodeIdentiferFieldOptions = useMemo(() => {
    const apiOptions = (episodeIdentiferFilterOptions.data || []).map(
      (item) => ({
        label: item,
        value: item,
      }),
    );

    const episode_identifier_search = [].concat(
      filtersPayload?.episode_identifier_search || [],
    );

    const selectedOptions = episode_identifier_search.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    episodeIdentiferFilterOptions.data,
    filtersPayload?.episode_identifier_search,
  ]);

  const MRNFieldOptions = useMemo(() => {
    const apiOptions = (MRNFilterOptions.data || []).map((item) => ({
      label: item,
      value: item,
    }));

    const medical_record_number = [].concat(
      filtersPayload?.medical_record_number || [],
    );

    const selectedOptions = medical_record_number.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [MRNFilterOptions.data, filtersPayload?.medical_record_number]);

  // const specialityFieldOptions = useMemo(() => {
  //   const apiOptions = (specialityFilterOptions?.data || []).map((item) => {
  //     labelCache.current.speciality[item.hospital_speciality_id] =
  //       item.speciality;

  //     return {
  //       label: item.speciality,
  //       value: item.hospital_speciality_id,
  //     };
  //   });

  //   const selectedOptions = (filtersPayload?.speciality_ids || []).map(
  //     (value) => ({
  //       value,
  //       label: labelCache.current.speciality[value] || value,
  //     }),
  //   );

  //   const map = new Map();
  //   [...selectedOptions, ...apiOptions].forEach((item) => {
  //     map.set(item.value, item);
  //   });

  //   return Array.from(map.values());
  // }, [specialityFilterOptions?.data, filtersPayload?.speciality_ids]);
  const specialityFieldOptions = useMemo(() => {
      const apiOptions = (specialityFilterOptions?.data || []).map((item) => {
        labelCache.current.speciality[item.hospital_speciality_id] =
          item.speciality;
  
        return {
          label: item.speciality,
          value: item.hospital_speciality_id,
        };
      });
  
      const selectedOptions = (filtersPayload?.speciality_ids || []).map(
        (value) => ({
          value,
          label: labelCache.current.speciality[value] || value,
        }),
      );
  
      const map = new Map();
      [...selectedOptions, ...apiOptions].forEach((item) => {
        map.set(item.value, item);
      });
  
      return Array.from(map.values());
    }, [specialityFilterOptions?.data, filtersPayload?.speciality_ids]);

  // const queueFieldOptions = useMemo(() => {
  //   const apiOptions = queueFilterOptions.data.map((item) => ({
  //     label: item?.queue_name,
  //     value: item?.queue_id,
  //   }));

  //   const selectedOptions = filtersPayload.queue_ids.map((value) => ({
  //     label: value,
  //     value: value,
  //   }));

  //   const map = new Map();

  //   [...selectedOptions, ...apiOptions].forEach((item) => {
  //     map.set(item.value, item);
  //   });

  //   return Array.from(map.values());
  // }, [queueFilterOptions.data, filtersPayload.queue_ids]);
  const queueFieldOptions = useMemo(() => {
    const apiOptions = (queueFilterOptions.data || []).map((item) => {
      labelCache.current.queue[item.queue_id] = item.queue_name;

      return {
        label: item.queue_name,
        value: item.queue_id,
      };
    });

    const selectedOptions = (filtersPayload.queue_ids || []).map((value) => ({
      value,
      label: labelCache.current.queue[value] || value,
    }));

    const map = new Map();
    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [queueFilterOptions.data, filtersPayload.queue_ids]);
  // const coderFieldOptions = useMemo(() => {
  //   const usersData =
  //     storedRole === "coder" ? coderFilterOptions?.data : auditorsFilterOptions?.data;
  //   console.log('coderFieldOptions - optionsSource:', usersData);
  //   const apiOptions = (usersData || []).map((item) => ({
  //     label: item?.user_name,
  //     value: item?.user_id,
  //   }));

  //   const selectedOptions = filtersPayload.coder_ids.map((value) => ({
  //     label: value,
  //     value: value,
  //   }));

  //   const map = new Map();

  //   [...selectedOptions, ...apiOptions].forEach((item) => {
  //     map.set(item.value, item);
  //   });

  //   return Array.from(map.values());
  // }, [coderFilterOptions.data,auditorsFilterOptions.data, filtersPayload.coder_ids]);
  const coderFieldOptions = useMemo(() => {
    const usersData =
      storedRole === "coder"
        ? coderFilterOptions?.data
        : auditorsFilterOptions?.data;

    const apiOptions = (usersData || []).map((item) => {
      labelCache.current.coder[item.user_id] = item.user_name;

      return {
        label: item.user_name,
        value: item.user_id,
      };
    });

    const selectedOptions = (filtersPayload.coder_ids || []).map((value) => {
    const user = usersData?.find((item) => item.user_id === value);
    const selectedUser = selectedCoderOptions?.find(
      (item) => item.value === value
    );
    return {
      value,
      label:
        user?.user_name ||
        selectedUser?.label ||
        labelCache.current.coder[value] ||
        value,
      };
    });

    const map = new Map();
    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    coderFilterOptions.data,
    auditorsFilterOptions.data,
    filtersPayload.coder_ids,
  ]);
  const priorityFiledOptions = useMemo(() => {
    const apiOptions = priorityFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.priority?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [priorityFilterOptions.data, filtersPayload?.priority]);

  //   const statusFiledOptions = useMemo(() => {
  //     const apiOptions = statusFilterOptions.data.map((item) => ({
  //       label: item.status,
  //       value: item.status_id,
  //     }));

  //     const selectedOptions = (filtersPayload?.status || []).map((value) => {
  //   const match = statusFilterOptions.data.find(
  //     (item) => item.status_id === value
  //   );

  //   return match
  //     ? { label: match.status, value: match.status_id }
  //     : null;
  // }).filter(Boolean);

  //     const map = new Map();

  //     [...selectedOptions, ...apiOptions].forEach((item) => {
  //       map.set(item.value, item);
  //     });

  //     return Array.from(map.values());
  //   }, [statusFilterOptions.data, filtersPayload?.status_ids]);

  const statusFiledOptions = useMemo(() => {
    const apiOptions = (statusFilterOptions.data || []).map((item) => {
      labelCache.current.status[item.status_id] = item.status;

      return {
        label: item.status,
        value: item.status_id,
      };
    });

    const selectedOptions = (filtersPayload?.status_ids || []).map((value) => ({
      value,
      label: labelCache.current.status[value] || value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [statusFilterOptions.data, filtersPayload?.status_ids]);

  const healthFundFieldOptions = useMemo(() => {
    const apiOptions = healthFundContractFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.health_fund_contract?.map(
      (value) => ({
        label: value,
        value: value,
      }),
    );

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [
    healthFundContractFilterOptions.data,
    filtersPayload?.health_fund_contract,
  ]);

  const provisionalDrgFieldOptions = useMemo(() => {
    const apiOptions = provisionalDrgFilterOptions.data.map((item) => ({
      label: item,
      value: item,
    }));

    const selectedOptions = filtersPayload?.drg_code?.map((value) => ({
      label: value,
      value: value,
    }));

    const map = new Map();

    [...selectedOptions, ...apiOptions].forEach((item) => {
      map.set(item.value, item);
    });

    return Array.from(map.values());
  }, [provisionalDrgFilterOptions.data, filtersPayload?.drg_code]);

  const hasValue = Object?.entries(filtersPayload)?.some(
    ([key, val]) =>
      !breadcrumbExcludeKeys?.includes(key) &&
      (Array.isArray(val) ? val?.length > 0 : !!val),
  );

  //Formate From and To Dates
  const formatYYYYMMDD = (d) =>
    d
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(d.getDate()).padStart(2, "0")}`
      : null;

  const handleApply = () => {
    const { medical_record_number, ...restFilters } = filtersPayload;

    const payload = {
      ...restFilters,
      is_global_search: false,
      medical_record_number: medical_record_number ?? [],

      los: transformLosForApi(
        filtersPayload.los_op,
        filtersPayload.los?.[0],
        filtersPayload.los?.[1],
      ),
      page_number: 1,
    };
    dispatch(
      getHealthInformationQueueManagerEpisodes({ storedRole, ...payload }),
    );
    dispatch(
      getHealthInformationManagerDashboardOptions({
        ...payload,
        screen_type: storedRole,
      }),
    );
    // onClose();
    setCoderSearchTerm("");
    setShowHimFilter(false);
    dispatch(updateFilters(payload));
  };

  const handleReset = () => {
    dispatch(resetHimFilters());
  };
  const labelMaps = {
    episode_identifier_search: episodeIdentiferFieldOptions,
    medical_record_number: MRNFieldOptions,
    speciality_ids: specialityFieldOptions,
    queue_ids: queueFieldOptions,
    coder_ids: coderFieldOptions,
    status: statusFiledOptions,
    priority: priorityFiledOptions,
    health_fund_contract: healthFundFieldOptions,
    los_op: losOperatorOptions,
    drg_code: provisionalDrgFieldOptions,
  };

  // const getLabel = (key, value) => {

  //   const mappedKey = key === "status_ids" ? "status" : key;
  //   if (
  //     key === "separation_date_from" ||
  //     key === "separation_date_to" ||
  //     key === "admission_date_from" ||
  //     key === "admission_date_to"
  //   ) {
  //     // value is "YYYY-MM-DD"
  //     const [y, m, d] = value.split("-");
  //     return `${d}/${m}/${y}`; // DD/MM/YYYY
  //   }

  //   const option = labelMaps[mappedKey]?.find((o) => o.value === value);
  //   console.log(option, 'option')
  //   return option ? option.label : value;
  // };
  const getLabel = (key, value) => {
    // map keys for lookup
    const mappedKey =
      key === "status_ids"
        ? "status"
        : key === "speciality_ids"
          ? "speciality_ids"
          : key === "queue_ids"
            ? "queue_ids"
            : key === "coder_ids"
              ? "coder_ids"
              : key;

    // date format
    if (
      key === "separation_date_from" ||
      key === "separation_date_to" ||
      key === "admission_date_from" ||
      key === "admission_date_to"
    ) {
      const [y, m, d] = value.split("-");
      return `${d}/${m}/${y}`;
    }

    // label lookup
    const option = labelMaps[mappedKey]?.find((o) => o.value === value);

    return option ? option.label : value;
  };
  const losOpLabelMap = {
    gt: ">",
    lt: "<",
    gte: ">=",
    lte: "<=",
    eq: "=",
    neq: "!=",
    gtlt: "Between",
    gtelte: "Between (Inclusive)",
  };

  const displayKeyMap = {
    episode_identifier_search: "Episode Identifier",
    medical_record_number: "MRN/UR",
    speciality_ids: "Speciality",
    queue_ids: "Queue",
    coder_ids: storedRole === "coder" ? "Coders" : "Auditors",
    status_ids: "Status",
    priority: "Priority",
    health_fund_contract: "Health Fund Contract",
    drg_code: "Provisional DRG",
  };

  const getLosBreadcrumbText = (operator, losArray) => {
    if (
      !operator ||
      !Array.isArray(losArray) ||
      !losArray.some((v) => typeof v === "number" && !isNaN(v))
    ) {
      return null;
    }

    const opText = losOpLabelMap[operator] || operator;

    // Single value
    if (losArray.length === 1) {
      return `${opText} ${losArray[0]} days`;
    }

    // Range
    if (losArray.length === 2) {
      return `${opText} ${losArray[0]} and ${losArray[1]} days`;
    }

    return null;
  };

  const transformLosForApi = (operator, value, toValue = "") => {
    console.log(value, toValue, operator, "los transform");
    const los = [];

    if (!operator || value === "" || value === undefined) return [];

    const losValue =
      value === "no_los" || value === null ? "No_los" : Number(value);
    // console.log(losValue,"los transform")

    const isRange = operator === "gtlt" || operator === "gtelte";

    if (isRange) {
      if (toValue === "") return [];
      const losToValue =
        toValue === "no_los" || toValue === null ? "No_los" : Number(toValue);
      los.push(losValue, losToValue);
    } else {
      los.push(losValue);
    }
    // console.log(los,"los transform")
    return los;
  };

  const debouncedSearchRef = useRef(
    debounce((thunk, value) => {
      dispatch(
        thunk({
          search: value || "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }, 1000),
  );

  const handleInputChange =
    (setSearchAction, fetchThunk) =>
    (value, { action }) => {
      if (action !== "input-change") {
        return;
      }
      dispatch(setSearchAction(value || ""));     
      debouncedSearchRef.current(fetchThunk, value);
    };

  const handleScrollBottom = (options, thunk) => () => {
    if (options.hasMore && !options.loading) {
      dispatch(
        thunk({
          search: options.search || "",
          page_number: options.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnFocus = (optionsState, fetchThunk) => {
    if (optionsState?.data?.length === 0 && !optionsState.loading) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleOnChange = async ({
    key,
    selected,
    optionsState,
    fetchThunk,
    searchResetAction,
    minVisible = 4,
  }) => {
    const selectedArray = selected || [];

    const selectedValues =
      key === "queue_ids" ||
      key === "coder_ids" ||
      key === "speciality_ids" ||
      key === "status_ids"
        ? selectedArray.map((s) => s.value)
        : selectedArray.map((s) => s.label);

    const finalValues = selectedValues

    // dispatch(updateFilters({ [key]: finalValues }));
    dispatch( updateFilters({
            ...filtersPayload,
            [key]: finalValues,
          }))

    if (optionsState.search) {
      dispatch(searchResetAction(""));
      debouncedSearchRef.current?.cancel?.();

      let currentPage = 1;
      let hasMore = true;
      let accumulatedData = [];

      while (hasMore) {
        const response = await dispatch(
          fetchThunk({
            search: "",
            page_number: currentPage,
            page_size: 10,
          }),
        ).unwrap();

        const dataMap = {
          episode_identifier_search: response.episode_identifier_number,
          medical_record_number: response.medical_record_number,
          speciality_ids: response?.specialities,
          queue_ids: response?.queues?.data,
          coder_ids: response?.users,
          priority: response?.priority,
          status: response?.status,
          health_funds: response?.health_funds,
          drg_code: response?.drg_codes,
        };

        const pageData = dataMap[key] || [];
        accumulatedData = [...accumulatedData, ...pageData];
        hasMore = response.has_more;
        const visibleOptions = accumulatedData.filter((item) => {
          const compareValue =
            key === "speciality_ids" || key === "queue_ids" || key === "coder_ids" || key === "status_ids" ? item.value : item;

          return !selectedValues.includes(compareValue);
        });

        if (visibleOptions.length >= minVisible) break;
        if (!hasMore) break;

        currentPage += 1;
      }
      return;
    }
    const visibleOptions = optionsState.data.filter((item) => {
      let compareValue;

      if (typeof item === "object") {
        if (key === "speciality_ids") {
          compareValue = item.hospital_speciality_id;
        } else if (key === "queue_ids") {
          compareValue = item.queue_id;
        } else if (key === "coder_ids") {
          compareValue = item.user_id;
        } else if (key === "status") {
          compareValue = item.status_id;
        } else {
          compareValue = item.value || item.label;
        }
      } else {
        compareValue = item;
      }

      return !selectedValues.includes(compareValue);
    });

    if (
      visibleOptions.length < minVisible &&
      optionsState.hasMore &&
      !optionsState.loading
    ) {
      dispatch(
        fetchThunk({
          search: "",
          page_number: optionsState.pageNumber + 1,
          page_size: 10,
        }),
      );
    }
  };

  const handleResetOnBlur = (stateKey, searchResetAction) => () => {
    debouncedSearchRef.current?.cancel?.();
    dispatch(searchResetAction(""));
  dispatch(resetFilterByKey(stateKey));
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="modal-xl"
    >
      <Modal.Header closeButton className="episode-list-modal-header-him">
        <Modal.Title className="episode-list-filter-modal-title-him">
          HIM Workspace Filters
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {hasValue && (
          <div className="episodelist-filter-breadcrumb-section-him">
            <div className="episodelist-breadcrumb-list-him">
              {Object.entries(filtersPayload)
                .filter(([key]) => !breadcrumbExcludeKeys.includes(key))
                .map(([key, value]) => {
                  if (!value || (Array.isArray(value) && value.length === 0))
                    return null;

                  if (key === "los") return null;

                  if (key === "los_op") {
                    const losText = getLosBreadcrumbText(
                      filtersPayload.los_op,
                      filtersPayload.los,
                    );
                    if (!losText) return null;

                    return (
                      <Badge
                        key="los"
                        bg="light"
                        text="dark"
                        className="episodeListFilterObj-breadcrumbItem-him"
                      >
                        LOS : {losText}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon-him"
                          onClick={() =>
                            dispatch(updateFilters({ los_op: "", los: [] }))
                          }
                        />
                      </Badge>
                    );
                  }

                  // Date fields
                  if (
                    key === "separation_date_from" ||
                    key === "separation_date_to" ||
                    key === "admission_date_from" ||
                    key === "admission_date_to"
                  ) {
                    const [y, m, d] = value.split("-");
                    return (
                      <Badge
                        key={key}
                        bg="light"
                        text="dark"
                        className="episodeListFilterObj-breadcrumbItem-him"
                      >
                        {/* {key.replace(/_/g, " ")} : {`${d}/${m}/${y}`} */}
                        {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                        {getLabel(key, value)}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon-him"
                          onClick={() =>
                            dispatch(updateFilters({ [key]: null }))
                          }
                        />
                      </Badge>
                    );
                  }

                  //  Array filters → one badge per value
                  // if (Array.isArray(value)) {
                  //   return value.map((item) => (
                  //     <Badge
                  //       key={`${key}-${item}`}
                  //       bg="light"
                  //       text="dark"
                  //       className="episodeListFilterObj-breadcrumbItem-him"
                  //     >
                  //       {/* {key.replace(/_/g, " ")} : {getLabel(key, item)} */}
                  //       {displayKeyMap[key] || key.replace(/_/g, " ")} : {getLabel(key, value)}
                  //       <img
                  //         src={closeIcon}
                  //         className="episodeListFilterObj-close-icon-him"
                  //         onClick={() =>
                  //           dispatch(
                  //             updateFilters({
                  //               [key]: value.filter((v) => v !== item),
                  //             }),
                  //           )
                  //         }
                  //       />
                  //     </Badge>
                  //   ));
                  // }
                  if (Array.isArray(value)) {
                    return value.map((item) => (
                      <Badge
                        key={`${key}-${item}`}
                        bg="light"
                        text="dark"
                        className="episodeListFilterObj-breadcrumbItem-him"
                      >
                        {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                        {getLabel(key, item)}
                        <img
                          src={closeIcon}
                          className="episodeListFilterObj-close-icon-him"
                          onClick={() =>
                            dispatch(
                              updateFilters({
                                [key]: value.filter((v) => v !== item),
                              }),
                            )
                          }
                        />
                      </Badge>
                    ));
                  }

                  // 🔹 Single-value filters
                  return (
                    <Badge
                      key={key}
                      bg="light"
                      text="dark"
                      className="episodeListFilterObj-breadcrumbItem-him"
                    >
                      {/* {key.replace(/_/g, " ")} : {getLabel(key, value)} */}
                      {displayKeyMap[key] || key.replace(/_/g, " ")} :{" "}
                      {getLabel(key, value)}
                      <img
                        src={closeIcon}
                        className="episodeListFilterObj-close-icon-him"
                        onClick={() => dispatch(updateFilters({ [key]: "" }))}
                      />
                    </Badge>
                  );
                })}
            </div>

            <Button className="episodelist-reset-btn" onClick={handleReset}>
              Clear All
            </Button>
          </div>
        )}

        <div className="workflow-him-filter-container">
          {/* EpisodeID */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Episode Identifier
            </label>
            <MultiSelect
              isMulti={true}
              options={episodeIdentiferFieldOptions}
              isLoading={episodeIdentiferFilterOptions.loading}
              hasMore={episodeIdentiferFilterOptions.hasMore}
              placeholder="Search episode identifer"
              onScrollBottom={handleScrollBottom(
                episodeIdentiferFilterOptions,
                getEpisodeIdentiferFilterOptions,
              )}
              onInputChange={handleInputChange(
                setEpisodeIdentiferFilterSearch,
                getEpisodeIdentiferFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  episodeIdentiferFilterOptions,
                  getEpisodeIdentiferFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("episodeIdentiferFilterOptions", setEpisodeIdentiferFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "episode_identifier_search",
                  selected,
                  optionsState: episodeIdentiferFilterOptions,
                  fetchThunk: getEpisodeIdentiferFilterOptions,
                  searchResetAction: setEpisodeIdentiferFilterSearch,
                });
              }}
              value={episodeIdentiferFieldOptions?.filter((o) =>
                filtersPayload?.episode_identifier_search?.includes(o?.value),
              )}
            />
          </div>
          {/* MRN */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">MRN/UR</label>
            <MultiSelect
              isMulti={true}
              options={MRNFieldOptions}
              isLoading={MRNFilterOptions.loading}
              hasMore={MRNFilterOptions.hasMore}
              placeholder="Search MRN"
              onScrollBottom={handleScrollBottom(
                MRNFilterOptions,
                getMRNFilterOptions,
              )}
              onInputChange={handleInputChange(
                setMRNFilterSearch,
                getMRNFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(MRNFilterOptions, getMRNFilterOptions);
              }}
              onBlur={handleResetOnBlur("MRNFilterOptions", setMRNFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "medical_record_number",
                  selected,
                  optionsState: MRNFilterOptions,
                  fetchThunk: getMRNFilterOptions,
                  searchResetAction: setMRNFilterSearch,
                });
              }}
              value={MRNFieldOptions.filter((o) =>
                filtersPayload.medical_record_number.includes(o.value),
              )}
            />
          </div>
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.admission_date_from
                  ? new Date(filtersPayload.admission_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateFilters({
                    admission_date_from: formatYYYYMMDD(date),
                    admission_date_to:
                      !date ||
                      (filtersPayload.admission_date_to &&
                        new Date(filtersPayload.admission_date_to) < date)
                        ? null
                        : filtersPayload.admission_date_to,
                  }),
                )
              }
              dateFormat="dd/MM/yyyy"
              className="workflow-him-filter-date-picker"
              placeholderText="Admission Date From"
              maxDate={new Date()}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Admission Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Admission from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.admission_date_to &&
                  filtersPayload.admission_date_from
                    ? new Date(filtersPayload.admission_date_to)
                    : null
                }
                onChange={(date) =>
                  dispatch(
                    updateFilters({ admission_date_to: formatYYYYMMDD(date) }),
                  )
                }
                dateFormat="dd/MM/yyyy"
                className="workflow-him-filter-date-picker"
                placeholderText="Admission Date To"
                disabled={!filtersPayload.admission_date_from}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={filtersPayload?.admission_date_from ?? null}
                maxDate={new Date()}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>
          {/* Separation Date From */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date From
            </label>
            <DatePicker
              selected={
                filtersPayload.separation_date_from
                  ? new Date(filtersPayload.separation_date_from)
                  : null
              }
              onChange={(date) =>
                dispatch(
                  updateFilters({
                    separation_date_from: formatYYYYMMDD(date),
                    separation_date_to:
                      !date ||
                      (filtersPayload.separation_date_to &&
                        new Date(filtersPayload.separation_date_to) < date)
                        ? null
                        : filtersPayload.separation_date_to,
                  }),
                )
              }
              dateFormat="dd/MM/yyyy"
              className="workflow-him-filter-date-picker"
              placeholderText="Separation Date From"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              maxDate={new Date()}
              minDate={
                filtersPayload?.admission_date_from ??
                filtersPayload?.admission_date_from
              }
              onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
            />
          </div>

          {/* Separation Date To */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Separation Date To
            </label>
            <div
              className={`${
                !filtersPayload.admission_date_from ? "datepicker-tooltip" : ""
              }`}
              data-title={
                "'To date' cannot be selected until 'Separation from date' is selected"
              }
            >
              <DatePicker
                selected={
                  filtersPayload.separation_date_to &&
                  filtersPayload.separation_date_from
                    ? new Date(filtersPayload.separation_date_to)
                    : null
                }
                onChange={(date) =>
                  dispatch(
                    updateFilters({ separation_date_to: formatYYYYMMDD(date) }),
                  )
                }
                dateFormat="dd/MM/yyyy"
                className="workflow-him-filter-date-picker"
                placeholderText="Separation Date To"
                disabled={!filtersPayload.separation_date_from}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={filtersPayload?.separation_date_from}
                maxDate={new Date()}
                onKeyDown={(e) => e.key !== "Backspace" && e.preventDefault()}
              />
            </div>
          </div>
          {/* Speciality */}
          <div className="workflow-him-filter-card">
            <label 
                htmlFor="speciality" className="workflow-him-filter-label">Speciality</label>
            <MultiSelect
              isMulti={true}
              options={specialityFieldOptions}
              isLoading={specialityFilterOptions.loading}
              hasMore={specialityFilterOptions.hasMore}
              placeholder="Search speciality"
              onScrollBottom={handleScrollBottom(
                specialityFilterOptions,
                getSpecialityFilterOptions,
              )}
              onInputChange={handleInputChange(
                setSpecialityFilterSearch,
                getSpecialityFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  specialityFilterOptions,
                  getSpecialityFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("specialityFilterOptions", setSpecialityFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "speciality_ids",
                  selected,
                  optionsState: specialityFilterOptions,
                  fetchThunk: getSpecialityFilterOptions,
                  searchResetAction: setSpecialityFilterSearch,
                });
              }}
              value={specialityFieldOptions.filter((o) =>
                filtersPayload.speciality_ids.includes(o.value),
              )}
            />
          </div>

          {/* Queue */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Queue</label>

            <MultiSelect
              isMulti={true}
              options={queueFieldOptions}
              isLoading={queueFilterOptions.loading}
              hasMore={queueFilterOptions.hasMore}
              placeholder="Search Queue"
              onScrollBottom={handleScrollBottom(
                queueFilterOptions,
                getQueueFilterOptions,
              )}
              onInputChange={handleInputChange(
                setQueueFilterSearch,
                getQueueFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(queueFilterOptions, getQueueFilterOptions);
              }}
              onBlur={handleResetOnBlur("queueFilterOptions", setQueueFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "queue_ids",
                  selected,
                  optionsState: queueFilterOptions,
                  fetchThunk: getQueueFilterOptions,
                  searchResetAction: setQueueFilterSearch,
                });
              }}
              value={queueFieldOptions.filter((o) =>
                filtersPayload.queue_ids.includes(o.value),
              )}
            />
          </div>

          {/* Coders */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              {storedRole === "coder" ? "Coders" : "Auditors"}
            </label>
            {storedRole === "coder" ? (
              <MultiSelect
                isMulti={true}
                options={coderFieldOptions}
                isLoading={coderFilterOptions.loading}
                hasMore={coderFilterOptions.hasMore}
                placeholder="Search Coders"
                onScrollBottom={handleScrollBottom(
                  coderFilterOptions,
                  getCoderFilterOptions,
                )}
                onInputChange={handleInputChange(
                  setCoderFilterSearch,
                  getCoderFilterOptions,
                )}
                onFocus={() => {
                  handleOnFocus(coderFilterOptions, getCoderFilterOptions);
                }}
                onBlur={handleResetOnBlur("coderFilterOptions", setCoderFilterSearch)}
                onChange={(selected) => {
                  handleOnChange({
                    key: "coder_ids",
                    selected,
                    optionsState: coderFilterOptions,
                    fetchThunk: getCoderFilterOptions,
                    searchResetAction: setCoderFilterSearch,
                  });
                }}
                value={coderFieldOptions.filter((o) =>
                  filtersPayload.coder_ids.includes(o.value),
                )}
              />
            ) : (
              <MultiSelect
                isMulti={true}
                options={coderFieldOptions}
                isLoading={auditorsFilterOptions.loading}
                hasMore={auditorsFilterOptions.hasMore}
                placeholder="Search Auditors"
                onScrollBottom={handleScrollBottom(
                  auditorsFilterOptions,
                  getAuditorsFilterOptions,
                )}
                onInputChange={handleInputChange(
                  setAuditorFilterSearch,
                  getAuditorsFilterOptions,
                )}
                onFocus={() => {
                  handleOnFocus(
                    auditorsFilterOptions,
                    getAuditorsFilterOptions,
                  );
                }}
                onBlur={handleResetOnBlur("auditorsFilterOptions", setAuditorFilterSearch)}
                onChange={(selected) => {
                  handleOnChange({
                    key: "coder_ids",
                    selected,
                    optionsState: auditorsFilterOptions,
                    fetchThunk: getAuditorsFilterOptions,
                    searchResetAction: setAuditorFilterSearch,
                  });
                }}
                value={coderFieldOptions?.filter((o) =>
                  filtersPayload.coder_ids.includes(o.value),
                )}
              />
            )}
          </div>

          {/* Priority */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Priority</label>
            <MultiSelect
              isMulti={true}
              options={priorityFiledOptions}
              isLoading={priorityFilterOptions.loading}
              hasMore={priorityFilterOptions.hasMore}
              placeholder="Search Priority"
              onScrollBottom={handleScrollBottom(
                priorityFilterOptions,
                getPriorityFilterOptions,
              )}
              onInputChange={handleInputChange(
                setPriorityFilterSearch,
                getPriorityFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(priorityFilterOptions, getPriorityFilterOptions);
              }}
              onBlur={handleResetOnBlur("priorityFilterOptions", setPriorityFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "priority",
                  selected,
                  optionsState: priorityFilterOptions,
                  fetchThunk: getPriorityFilterOptions,
                  searchResetAction: setPriorityFilterSearch,
                });
              }}
              value={priorityFiledOptions.filter((o) =>
                filtersPayload?.priority?.includes(o?.value),
              )}
            />
          </div>

          {/* Status */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Status</label>
            <MultiSelect
              isMulti={true}
              options={statusFiledOptions}
              isLoading={statusFilterOptions.loading}
              hasMore={statusFilterOptions.hasMore}
              placeholder="Search Status"
              onScrollBottom={handleScrollBottom(
                statusFilterOptions,
                getStatusFilterOptions,
              )}
              onInputChange={handleInputChange(
                setStatusFilterSearch,
                getStatusFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(statusFilterOptions, getStatusFilterOptions);
              }}
              onBlur={handleResetOnBlur("statusFilterOptions", setStatusFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "status_ids",
                  selected,
                  optionsState: statusFilterOptions,
                  fetchThunk: getStatusFilterOptions,
                  searchResetAction: setStatusFilterSearch,
                });
              }}
              value={statusFiledOptions?.filter((o) =>
                filtersPayload?.status_ids?.includes(o?.value),
              )}
            />
          </div>

          {/* Health Fund Contract */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">
              Health Fund Contract
            </label>
            <MultiSelect
              isMulti={true}
              options={healthFundFieldOptions}
              isLoading={healthFundContractFilterOptions.loading}
              hasMore={healthFundContractFilterOptions.hasMore}
              placeholder="Search Health Fund Contract"
              onScrollBottom={handleScrollBottom(
                healthFundContractFilterOptions,
                getHealthFundContractFilterOptions,
              )}
              onInputChange={handleInputChange(
                setHealthFundFilterContractSearch,
                getHealthFundContractFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  healthFundContractFilterOptions,
                  getHealthFundContractFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("healthFundContractFilterOptions", setHealthFundFilterContractSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "health_fund_contract",
                  selected,
                  optionsState: healthFundContractFilterOptions,
                  fetchThunk: getHealthFundContractFilterOptions,
                  searchResetAction: setHealthFundFilterContractSearch,
                });
              }}
              value={healthFundFieldOptions.filter((o) =>
                filtersPayload.health_fund_contract.includes(o.value),
              )}
            />
          </div>

          {/* LOS Operator */}
          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">LOS Operator</label>
            <Select
              options={losOperatorOptions}
              placeholder="Select Operator"
              value={
                filtersPayload.los_op
                  ? losOperatorOptions.find(
                      (o) => o.value === filtersPayload.los_op,
                    )
                  : ""
              }
              onChange={(selected) => {
                dispatch(
                  updateFilters({
                    los_op: selected?.value || "",
                    los: [],
                  }),
                );
              }}
              classNamePrefix="react-select"
            />
          </div>

          {/* Single LOS value */}
          {!["gtlt", "gtelte"].includes(filtersPayload.los_op) && (
            <div className="workflow-him-filter-card">
              <label className="workflow-him-filter-label">
                Length of Stay (LOS)
              </label>
              <div
                className={`${
                  !filtersPayload.los_op ? "datepicker-tooltip" : ""
                }`}
                data-title={"Select LOS operator to enable"}
              >
                <input
                  type="number"
                  min="0"
                  className="workflow-him-filter-input"
                  value={filtersPayload.los?.[0] ?? ""}
                  disabled={!filtersPayload.los_op}
                  onKeyDown={(e) => {
                    if (e.key === "e" || e.key === "E") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    dispatch(
                      updateFilters({
                        los: value === "" ? [] : [Number(value)],
                      }),
                    );
                  }}
                  placeholder="Enter LOS"
                />
              </div>
            </div>
          )}

          {/* LOS Range */}
          {["gtlt", "gtelte"].includes(filtersPayload.los_op) && (
            <>
              <div className="workflow-him-filter-card">
                <label className="workflow-him-filter-label">LOS From</label>
                <input
                  type="number"
                  min="0"
                  className="workflow-him-filter-input"
                  value={filtersPayload.los?.[0] ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    dispatch(
                      updateFilters({
                        los:
                          value === ""
                            ? []
                            : [Number(value), filtersPayload.los?.[1]],
                      }),
                    );
                  }}
                  placeholder="From days"
                />
              </div>

              <div className="workflow-him-filter-card">
                <label className="workflow-him-filter-label">LOS To</label>
                <input
                  type="number"
                  min="0"
                  className="workflow-him-filter-input"
                  value={filtersPayload.los?.[1] ?? ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    dispatch(
                      updateFilters({
                        los:
                          filtersPayload.los?.[0] === undefined && value === ""
                            ? []
                            : [
                                filtersPayload.los?.[0],
                                value === "" ? undefined : Number(value),
                              ],
                      }),
                    );
                  }}
                  placeholder="To days"
                />
              </div>
            </>
          )}

          <div className="workflow-him-filter-card">
            <label className="workflow-him-filter-label">Provisional DRG</label>
            <MultiSelect
              isMulti={true}
              options={provisionalDrgFieldOptions}
              isLoading={provisionalDrgFilterOptions.loading}
              hasMore={provisionalDrgFilterOptions.hasMore}
              placeholder="Search DRG"
              onScrollBottom={handleScrollBottom(
                provisionalDrgFilterOptions,
                getProvisionalDrgFilterOptions,
              )}
              onInputChange={handleInputChange(
                setProvisionalDrgFilterSearch,
                getProvisionalDrgFilterOptions,
              )}
              onFocus={() => {
                handleOnFocus(
                  provisionalDrgFilterOptions,
                  getProvisionalDrgFilterOptions,
                );
              }}
              onBlur={handleResetOnBlur("provisionalDrgFilterOptions", setProvisionalDrgFilterSearch)}
              onChange={(selected) => {
                handleOnChange({
                  key: "drg_code",
                  selected,
                  optionsState: provisionalDrgFilterOptions,
                  fetchThunk: getProvisionalDrgFilterOptions,
                  searchResetAction: setProvisionalDrgFilterSearch,
                });
              }}
              value={provisionalDrgFieldOptions.filter((o) =>
                filtersPayload.drg_code.includes(o.value),
              )}
            />
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="episode-list-filter-modal-footer">
        <Button
          className="el-filter-cancel btn btn-secondary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button className="el-filter-submit" onClick={handleApply}>
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HimManagerFilter;